import { createContainer } from "unstated-next";
import {
  ActivityTypeCode,
  PresentTypeCode,
  CouponTypeCode,
} from "project-config/constants";
import { accDiv, accMul } from "project-config/utils/acc";
import { BindActivityInfo } from "@/components/top-up/types";
import i18next from "i18next";

function useActivityInfoStoreHook() {
  const isZh = i18next.language === "zh";

  const isYouthActivity = (activitySource: BindActivityInfo) => {
    return activitySource?.activityType === ActivityTypeCode.QingCloudGift;
  };

  const presentAmountCalculate = (
    activitySource: BindActivityInfo,
    amount?: number,
    presentamount?: number
  ) => {
    if (amount === undefined || presentamount)
      return activitySource?.presentType === PresentTypeCode.Proportion
        ? Math.ceil(accDiv(accMul(amount, presentamount), 100))
        : presentamount;
  };

  const isQingCloudGPU = (activitySource: BindActivityInfo) => {
    return (
      isYouthActivity(activitySource) &&
      activitySource?.activityDetail[0].couponType ===
        CouponTypeCode.GPUQingCloud
    );
  };
  const rulesContentList = (activitySource?: BindActivityInfo) => {
    const rulesText = !isZh ? activitySource?.rulesEn : activitySource?.rulesCn;
    return rulesText?.split("\n");
  };

  return {
    isYouthActivity,
    presentAmountCalculate,
    isQingCloudGPU,
    rulesContentList,
  };
}

const ActivityInfoStoreContainer = createContainer(useActivityInfoStoreHook);
const ActivityInfoStoreProvider = ActivityInfoStoreContainer.Provider;

export default ActivityInfoStoreProvider;

export function useActivityInfoStore() {
  return ActivityInfoStoreContainer.useContainer();
}
